import { defineComponent as w, defineAsyncComponent as E, ref as i, computed as o } from "vue";
import v, { DropdownMenuItem as u, DropdownMenuTypes as s } from "@ado/dropdown-menu-ld";
import { Variants as e } from "../types/index.js";
import { submitInternalEventAndRedirectToPage as O } from "../../../shared/data/tracking/utilities/index.js";
import { TRACKING_EVENTS as c } from "../../../shared/data/tracking/types/index.js";
import { submitInternalEvent as h } from "@ado/tracking-library";
import "@ado/acs-standard-library/style.css";
import "@ado/dropdown-menu-ld/style.css";
import { useBaseApplicationTranslation as D } from "../../../shared/libraries/local-translations/index.js";
const W = w({
  name: "CountrySelector",
  components: {
    CountrySelectorMoreDialog: E(
      () => import("./index4.js")
    ),
    DropdownMenu: v
  },
  props: {
    variant: {
      type: String,
      required: !0
    },
    countries: {
      type: Array,
      required: !0
    },
    currentCountry: {
      type: Object,
      required: !0
    },
    hasArrow: {
      type: Boolean,
      default: !0
    },
    showOnlyCurrentCountry: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const l = e, r = i(!1), a = i(), m = () => {
      a.value.toggleMenuItemsVisibility({ target: null }), r.value = !0;
      const n = {
        ...c.HEADER_COUNTRY_DROPDOWN_CLICK,
        extra: "More"
      };
      h(n);
    }, p = o(() => [
      ...t.countries.filter(
        (n) => n.isMajorCountry === !0 && n.countryCode !== t.currentCountry.countryCode
      ).map(
        (n) => u.newCustomItem(
          n.countryCode,
          "country-dropdown-menu-item",
          n
        )
      ),
      u.newCustomItem(
        "more-countries-dropdown-menu-item",
        "more-countries-dropdown-menu-item"
      )
    ]), d = o(() => t.variant === e.NamedFlagWithExpansionOnClick || t.variant === e.FlagWithExpansionOnClick ? s.ExpandOnClick : s.ExpandOnHover), C = o(() => {
      switch (t.variant) {
        case e.FlagWithExpansionOnClick:
          return "country-selector-flag-with-expansion-on-click";
        case e.FlagWithExpansionOnHover:
          return "country-selector-flag-with-expansion-on-hover";
        default:
          return "country-selector-named-flag-with-expansion-on-click";
      }
    }), y = (n) => {
      const g = {
        ...c.HEADER_COUNTRY_DROPDOWN_CLICK,
        extra: n.name
      };
      O(g, {
        url: n.canonicalUrl
      });
    }, { t: f } = D();
    return {
      countryVariants: l,
      showDialog: r,
      openDialog: m,
      countryMenuItems: p,
      dropdownMenuType: d,
      variantCssClass: C,
      dropdownMenuRef: a,
      handleCountryClick: y,
      t: f
    };
  }
});
export {
  W as default
};
//# sourceMappingURL=index2.js.map
